module.exports = __webpack_public_path__ + "static/videos/collage3.69d3e48.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/collage3.mp4
// module id = sia5
// module chunks = 1